import type { MessageToServiceWorker } from "@src/types";

import { useOfflineModeState } from "@src/states/offline_mode";

import { isSupported } from "@src/utils/serviceWorker/isSupported";

/**
 * Retrieves the activated Service Worker.
 * @returns A Promise that resolves to the activated ServiceWorker.
 * @throws Error if Service Worker is not supported.
 */
export function getServiceWorker() {
  return new Promise<ServiceWorker>((resolve, reject) => {
    const { supported, message } = isSupported();
    if (!supported) {
      useOfflineModeState.setState({
        color: "red",
        error: message,
      });
      reject(new Error(message));
      return;
    }

    let skipWaiting = false;
    let listening = false;

    const afterRegister = (reg: ServiceWorkerRegistration) => {
      const waitActivate = setInterval(() => {
        if (reg.waiting && !skipWaiting) {
          console.log("Asking Service Worker to skip waiting");
          skipWaiting = true;
          const message: MessageToServiceWorker = {
            idRadio: "",
            type: "SKIP_WAITING",
          };
          reg.waiting.postMessage(message);
          return;
        }

        const sw = reg.active || reg.waiting || reg.installing;
        if (!sw) return;

        if (sw.state === "activated") {
          clearInterval(waitActivate);
          resolve(sw);
          return;
        } else if (!listening) {
          listening = true;
          sw.addEventListener("statechange", function onStateChange() {
            if (sw.state === "activated") {
              sw.removeEventListener("statechange", onStateChange);
              clearInterval(waitActivate);
              resolve(sw);
              return;
            }
          });
        }
      }, 500);
    };

    const waitRegister = setInterval(() => {
      navigator.serviceWorker.getRegistration().then((reg) => {
        if (reg) {
          clearInterval(waitRegister);
          afterRegister(reg);
        }
      });
    }, 500);
  });
}
